import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from 'axios';
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// const API = 'http://localhost:4000';
const API = 'https://backend-zoho.vercel.app';
const HUBSPOT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/3797225/be316fe8-ea4c-4aa2-ad2a-b5750f006e01';

const Modal_contact_zoho = ({ setIsOpen }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const toastIdRef = useRef(null);

  // 1) Añade este helper al inicio del componente:
const wait = ms => new Promise(res => setTimeout(res, ms));

const getHubspotIds = async (email, companyName, maxAttempts = 10, delayMs = 2000) => {
  let contactId = null;
  let companyId = null;

  for (let i = 0; i < maxAttempts; i++) {
    if (!contactId) {
      contactId = await searchHubspotContact(email);
    }
    if (!companyId) {
      companyId = await searchHubspotCompany(companyName);
    }
    // Si ya obtuvimos ambos, salimos
    if (contactId && companyId) break;
    // Si aún falta alguno, esperamos y reintentamos
    await wait(delayMs);
  }

  return { contactId, companyId };
};

  const [formData, setFormData] = useState({
    First_Name: '',
    Last_Name: '',
    Email: '',
    Phone: '',
    Company: '',
    Descripci_n: '',
    Lead_Source: ''
  });
  const [storedCountry, setStoredCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [ipAddress, setIpAddress] = useState('');

  const countryNames = {
    costarica: "Costa Rica",
    elsalvador: "El Salvador",
    mexico: "México",
    panama: "Panamá",
    venezuela: "Venezuela",
    colombia: "Colombia",
  };
  const compareCountry = (stored, name) => stored?.toLowerCase() === name.toLowerCase();

  // useEffect(() => {
  //   axios.get('https://api.ipify.org?format=json')
  //     .then(res => setIpAddress(res.data.ip))
  //     .catch(() => {});
  // }, []);

  // useEffect(() => {
  //   const savedCountry = localStorage.getItem("selectedCountry") || "No disponible";
  //   setStoredCountry(savedCountry);
  //   const formattedCountry = countryNames[savedCountry.toLowerCase()] || savedCountry;
  //   setFormData(prev => ({
  //     ...prev,
  //     Lead_Source: `Formulario Web Invu ${formattedCountry}`
  //   }));
  // }, []);

  useEffect(() => {
    const savedCountry = localStorage.getItem("selectedCountry") || "No disponible";
    setStoredCountry(savedCountry);
  
    let formattedCountry;
    switch (savedCountry) {
      case "Costarica":
        formattedCountry = "Costa Rica";
        break;
      case "Elsalvador":
        formattedCountry = "El Salvador";
        break;
      case "mexico":
        formattedCountry = "México";
        break;
      case "panama":
        formattedCountry = "Panamá";
        break;
      case "Republicadominicana":
        formattedCountry = "República Dominicana";
        break;
      case "Unitedstates":
        formattedCountry = "Estados Unidos";
        break;
      case "Trinidadytobago":
        formattedCountry = "Trinidad y Tobago";
        break;
      default:
        formattedCountry = savedCountry;
    }
  
    setFormData(prev => ({
      ...prev,
      Lead_Source: `Formulario Web Invu ${formattedCountry}`
    }));
  }, []);

  const handleChange = e => setFormData(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleCheckboxChange = e => setIsChecked(e.target.checked);

  // Llama a backend para buscar ID en HubSpot
  const searchHubspotContact = async (email) => {
    try {
      const resp = await axios.get(`${API}/api/hubspot-search`, { params: { email } });
      return resp.data.id;
    } catch {
      return null;
    }
  };

  const searchHubspotCompany = async (companyName) => {
    try {
      const resp = await axios.get(`${API}/api/hubspot-search-company`, { params: { companyName } });
      return resp.data.companyId;
    } catch {
      return null;
    }
  };

  const submitToZoho = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      setError("Debes aceptar la política de privacidad antes de continuar.");
      return null;
    }
    const { First_Name, Last_Name, Email, Company, Descripci_n } = formData;
    if (!First_Name || !Last_Name || !Email || !phone || !Company || !Descripci_n) {
      setError("Todos los campos son obligatorios.");
      return null;
    }
    setError("");
    setLoading(true);
    try {
      const payload = { ...formData, Phone: phone };
      const resp = await axios.post(`${API}/api/zoho/submit-all`, payload);
      return resp.data;
    } catch (err) {
      alert(`❌ Error al enviar el formulario a Zoho:\n${err.response?.data?.error || err.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // Envía a Forms y espera hasta obtener el ID de HubSpot
  const submitToHubspot = async () => {
    const data = { fields: [
      { name: "email", value: formData.Email },
      { name: "firstname", value: formData.First_Name },
      { name: "lastname", value: formData.Last_Name },
      { name: "mobilephone", value: phone },
      { name: "name", value: formData.Company, objectTypeId: "COMPANY" },
      { name: "message", value: formData.Descripci_n },
      { name: "hs_lead_status", value: "Nuevo", objectTypeId: "CONTACT" }
    ],
  };

    try {
      await axios.post(HUBSPOT_URL, data, { headers: { 'Content-Type': 'application/json' } });
      // Poll each 2s hasta 5 intentos
      let hubspotId = null;
      for (let i = 0; i < 5; i++) {
        hubspotId = await searchHubspotContact(formData.Email);
        if (hubspotId) break;
        await new Promise(r => setTimeout(r, 2000));
      }
      return hubspotId;
    } catch {
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    toastIdRef.current = toast.loading(
      'Enviando datos… por favor espere un momento',
      {
        autoClose: false,
        className: 'bg-green-500 text-white rounded-lg shadow-md',
        bodyClassName: 'font-medium',
        progressClassName: 'bg-white'
      }
    );
    setLoading(true);
  
    const zohoData = await submitToZoho(e);
    if (!zohoData) {
      toast.update(toastIdRef.current, {
        render: '❌ Error',
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        className: 'bg-red-500 text-white rounded-lg shadow-md',
        bodyClassName: 'font-medium',
        progressClassName: 'bg-white'
      });
      setLoading(false);
      return;
    }
  
    
    // 2.1) Lanzas el Forms de HubSpot (igual que antes)
    await submitToHubspot();

    // 2.2) Hacemos polling de ambos IDs hasta que tengamos contacto y compañía
    const {
      contactId: hubspotContactId,
      companyId: hubspotCompanyId
    } = await getHubspotIds(formData.Email, formData.Company);
  
    const { leadId, accountId, contactId } = zohoData;
  
    history.push(
      `/zoho-contact-two?lead_id=${leadId}` +
      `&org_id=${accountId}` +
      `&person_id=${contactId}` +
      `&hubspot_contact_id=${hubspotContactId || ""}` +
      `&hubspot_company_id=${hubspotCompanyId || ""}`
    );
  
    toast.update(toastIdRef.current, {
      render: 'Formulario enviado con éxito!',
      type: 'success',
      isLoading: false,
      autoClose: 2000,
      className: 'bg-green-500 text-white rounded-lg shadow-md',
      bodyClassName: 'font-medium',
      progressClassName: 'bg-white'
    });
    setLoading(false);
  };

  return (
    <>
      <ToastContainer
        position="bottom-center"
        hideProgressBar={false}
        newestOnTop={false}
        draggable
        theme="colored"               // usa paleta de colores
        toastClassName="px-4 py-3 rounded-lg shadow-lg"    // añade padding, bordes redondeados y sombra
        bodyClassName="font-medium"
      />
    <div className="flex justify-center items-center fixed inset-0 z-50 bg-gray-500 bg-opacity-75">
      <div className="flex flex-col w-11/12 sm:w-5/6 lg:w-1/2 max-w-2xl mx-auto rounded-lg border border-gray-300 shadow-xl bg-white">
        <form onSubmit={handleSubmit}>
          <div className="flex justify-between p-6 border-b border-gray-200">
            <p className="font-semibold text-gray-800">{t("modaltrydemo")}</p>
            <button type="button" onClick={() => setIsOpen(false)}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="px-6 py-5 bg-gray-50">
            <div className="mb-6">
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                <img
                  className="h-16 w-auto cursor-pointer"
                  src="https://res.cloudinary.com/dslkvd23s/image/upload/v1648001932/Branding%20Invu%20/Logo%20Invu/logo-INVU-POS-rgb_nrg6ry.png"
                  alt="Logo"
                />
              </Link>
            </div>

            <div className="flex flex-col mt-6 sm:flex-row items-center mb-1 sm:space-x-5">
              <input
                name="First_Name"
                placeholder="Nombre"
                onChange={handleChange}
                required
                className="w-full p-4 mb-3 border rounded"
              />
              <input
                name="Last_Name"
                placeholder="Apellido"
                onChange={handleChange}
                required
                className="w-full p-4 mb-3 border rounded"
              />
            </div>

            <div className="flex flex-col sm:flex-row items-center mb-1 sm:space-x-5">
              <input
                name="Email"
                type="email"
                placeholder="Correo electrónico"
                onChange={handleChange}
                required
                className="w-full p-4 mb-3 border rounded"
              />

              <PhoneInput
                className="w-full p-4 mb-3 bg-white border border-gray-200 rounded shadow-sm"
                placeholder={t("modalphone")}
                defaultCountry={
                  compareCountry(storedCountry, 'Mexico') ? "MX" :
                  compareCountry(storedCountry, 'Venezuela') ? "VE" :
                  compareCountry(storedCountry, 'Elsalvador') ? "SV" :
                  compareCountry(storedCountry, 'Costarica') ? "CR" :
                  compareCountry(storedCountry, 'Colombia') ? "CO" :
                  compareCountry(storedCountry, 'Guatemala') ? "GT" :
                  compareCountry(storedCountry, 'Republicadominicana') ? "DO" :
                  compareCountry(storedCountry, 'Unitedstates') ? "US" :
                  compareCountry(storedCountry, 'Trinidadytobago') ? "TT" :
                  "PA"
                }
                required
                value={phone}
                onChange={setPhone}
              />
            </div>

            <div className="mb-1">
              <input
                name="Company"
                placeholder="Nombre del negocio"
                onChange={handleChange}
                required
                className="w-full p-4 mb-3 border rounded"
              />
            </div>

            <textarea
              name="Descripci_n"
              placeholder="Mensaje"
              rows={4}
              onChange={handleChange}
              className="w-full p-4 mb-3 border rounded"
            />

            <div className="mt-3 flex items-start">
              <div className="flex">
                <input
                  type="checkbox"
                  required
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  className="shrink-0 mt-1.5 text-blue-600 border-gray-200 rounded focus:ring-blue-500"
                />
              </div>
              <div className="ms-3 ml-2">
                <label className="text-sm text-gray-500">
                  {t("contactexternalformpolicy1")} {" "}
                  <Link to="/politicas-de-privacidad" className="text-indigo-600 underline font-medium">
                    {t("contactexternalformpolicyspan")}
                  </Link> {" "}
                  {t("contactexternalformpolicy2")}
                </label>
              </div>
            </div>

            {error && <p className="text-red-500 mt-2">{error}</p>}
          </div>

          <div className="flex justify-between p-5 border-t border-gray-200 items-center">
            <p onClick={() => setIsOpen(false)} className="font-semibold text-gray-600 cursor-pointer">
              Cancelar
            </p>
            <button type="submit" className="px-8 py-3 bg-indigo-500 text-white rounded hover:opacity-90">
              {t("modalformbutton")}
            </button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
};

export default Modal_contact_zoho;
